import { FooterCopyright } from "./styles";
import utils from "@metrojs/utils";
/**
 * フッターコピーライトコンポーネント
 *
 * @returns {JSX.Element} フッターコピーライトのコンポーネント
 */
export default function FooterCopyrightComponent({ mode, group = null, style = {} }) {
  if (utils.isNull(group)) {
    group = "ダイレクトオーダー事務局";

    const isDisplay = !(mode == "kyoto_seibi" || mode == "aspc" || mode == "finalparts" || mode == "ichinen" || mode == "junps");
    if (isDisplay) {
      return (
        <FooterCopyright style={{ ...style }}>
          Copyright(C) <a href="https://www.direct-order.jp/">ダイレクトオーダー事務局</a> All Rights Reserved.
        </FooterCopyright>
      );
    } else {
      return (
        <FooterCopyright style={{ ...style }}>
        </FooterCopyright>
      );
    }
  } else {
    if (utils.hasOwn(group, "CashBackRatio")) {
      return null;
    } else {
      return (
        <FooterCopyright style={{ ...style }}>
          Copyright(C) <a href="https://www.direct-order.jp/">ダイレクトオーダー事務局</a> All Rights Reserved.
        </FooterCopyright>
      );
    }
  }
}
